"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ApiError extends Error {
    constructor(message, statusCode, data) {
        super(message);
        this.data = data;
        this.statusCode = statusCode;
    }
}
exports.default = ApiError;
